import { useEventHandler } from '../../../../hooks/useEventHandler';
import { toastStore } from '../../components/Toaster';
import { createToastOptionsWithDefaults } from './logic/createToastOptionsWithDefaults';
import { ToastOptions } from './types/ToastOptions';
import { UseToast } from './types/useToast';

export const useToast = (): UseToast => {
  const resetToastDuration = useEventHandler(
    (id: Exclude<ToastOptions['id'], undefined>, options: ToastOptions) => {
      // zag js toasts dont support updating duration directly, so we have to do a workaround
      toastStore.update(id, {
        ...createToastOptionsWithDefaults(options),
        duration: Number.POSITIVE_INFINITY,
      });
      toastStore.update(id, createToastOptionsWithDefaults(options));
    },
  );

  const toast = useEventHandler((options: ToastOptions) => {
    const toastWithMatchingId = toastStore
      .getVisibleToasts()
      .find((visibleToast) => visibleToast.id === options.id);

    if (toastWithMatchingId?.id) {
      resetToastDuration(toastWithMatchingId.id, options);
      return;
    }

    toastStore.create(createToastOptionsWithDefaults(options));
  });

  return toast;
};
